// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9n-3";
export var contentContainer = "_9n-0";
export var editorContainer = "_9n-1";
export var quillInputForm = "_9n-2";
export var zoneDivider = "_9n-4";